import { DictionaryType } from './types';

// !костыльная проверка на тип при преобразовании массива в словарь  =\
/** выкинет ошибку, есл и это объект (не примитив) */
function checkElementTypeForDictionary(element: any, key: string) {
  if (typeof element === 'object') throw new Error(`getDictionary > Тип array[X][${key}] должен быть простым`);
  if (typeof element === 'undefined') console.error(`getDictionary > Тип array[X][${key}] undefined`);
}

/**
 * Преобразование массива элементов в словарь:
 * * а) где array[X][key] с УНИКАЛЬНЫМ значением присваивается элемент(объект) массива array
 * * б) если есть `key2`, то к выбранному array[X][key][key2] присваивается элемент массива array
 * **note:** Значения для`key` должны быть простым типом, не пустыми и УНИКАЛЬНЫМИ(иначе будет перезапись).
 * @param array массив, который преобразовываем в словарь
 * @param key ключ из элемента (объекта) массива первого уровня (array[X][key])
 *            для значений которых будет назначены элементы, если нет `key2`
 * @param key2 ключ из объекта, который являлся значением для `key`,
 *            далее для значений array[X][key][key2] будут назначены элементы массива
 * @example
 * const array = [
 *  {id: 1, name: 'name1', age: 1, test: {id: 11}},
 *  {id: 2, name: 'name2', age: 2, test: {id: 22}},
 *  {id: 3, name: 'name1', age:3, test: {id: 33}}
 * ];
 * const dictionary = getDictionaryByElementProperty(array, 'id');
 * // result dictionary:
 * {
 *  1: {
 *      id: 1,
 *      name: "name1",
 *      age: 1
 *  },
 *  2: {
 *      id: 2,
 *      name: "name2",
 *      age: 2
 *  },
 *  3: {
 *      id: 3,
 *      name: "name1",
 *      age: 3
 *  }
 * }
 * const dictionary2 = getDictionaryByElementProperty(array, 'test', 'id');
 *  // result dictionary2:
 * {
 *  11: {
 *      id: 1,
 *      name: "name1",
 *      age: 1,
 *      test: {
 *          id: 11
 *      }
 *  },
 *  22: {
 *      id: 2,
 *      name: "name2",
 *      age: 2,
 *      test: {
 *          id: 22
 *      }
 *  },
 *  33: {
 *      id: 3,
 *      name: "name1",
 *      age: 3,
 *      test: {
 *          id: 33
 *      }
 *  }
 * }
 */
export function getDictionaryByElementProperty<T extends {[key: string]: any}>(array: T[], key: keyof T, key2?: string) {
  if (array.length === 0) return {};

  if (key2) checkElementTypeForDictionary(array[0][key][key2], key as string);
  else checkElementTypeForDictionary(array[0][key], key as string);

  return array.reduce((acc, element) => {
    const elementKeyValue = key2 ? element[key][key2] : element[key];

    if (elementKeyValue) {
      acc[elementKeyValue] = element;
    }
    return acc;
  }, {} as DictionaryType<T>);
}

/**
 * Преобразование массива элементов в словарь, где к выбранному `key` присваивается группа(массив) элементов(объектов), в котором есть `key`.  
 * **note:** Значения array[X][key] должно быть простым типом и не пустым.
 * @param array массив, который преобразовываем в словарь
 * @param key ключ из элемента массива, по значению для которого(ключа) будут сгруппированы массивы элементов
 * @example
 * const array = [{id: 1, name: 'name1', age: 1}, {id: 2, name: 'name2', age: 2}, {id: 3, name: 'name1', age:3}];
 * const dictionary = getDictionaryByElementPropertyForElements(array, 'name');
 * // в итоге dictionary будет:
 * {
    name1: [
        {
          id: 1,
          name: "name1",
          age: 1
        },
        {
          id: 3,
          name: "name1",
          age: 3
        }
    ],
    name2: [
        {
          id: 2,
          name: "name2",
          age: 2
        }
    ]
}
 */
export function getDictionaryByElementPropertyForElements<T extends {[key: string]: any}>(array: T[], key: keyof T) {
  if (array.length === 0) return {};

  checkElementTypeForDictionary(array[0][key], key as string);

  return array.reduce((acc, element) => {
    const elementKeyValue = element[key];

    if (elementKeyValue && elementKeyValue !== 0) {
      if (!acc[elementKeyValue]) acc[elementKeyValue] = [];
      acc[elementKeyValue].push(element);
    }

    return acc;
  }, {} as DictionaryType<T[]>);
}
